import React from "react"
import MainBlogPostStyle from "./MainBlogPostStyle.module.styl"
import Image from "gatsby-image"
import { Link } from "gatsby"

const MainBlogPost = ({ mainBlog }) => {
  return (
    <div key={mainBlog.id} className={MainBlogPostStyle.holder}>
      <Link
        className={MainBlogPostStyle.image_holder}
        to={`/${mainBlog.slug}/`}
      >
        <Image
          alt="blog-post-image"
          className={MainBlogPostStyle.image_holder}
          fluid={mainBlog.mainImage.fluid}
        />
      </Link>

      <div className={MainBlogPostStyle.blog_post_content}>
        <Link to={`/${mainBlog.slug}/`} className={MainBlogPostStyle.title}>
          {mainBlog.title}
        </Link>
        <div className={MainBlogPostStyle.description}>
          {mainBlog.intro.content.slice(0, 1).map((text, index) => {
            return (
              <div key={index}>
                {text.content.map(t => {
                  return <p key={index}>{t.value}</p>
                })}
              </div>
            )
          })}
        </div>
        <div className={MainBlogPostStyle.author_holder}>
          <div className={MainBlogPostStyle.author}>
            <Image
              className={MainBlogPostStyle.author_image_holder}
              fluid={mainBlog.author.avatar.fluid}
            />

            <Link
              to={`/${mainBlog.author.slug}/`}
              className={MainBlogPostStyle.author_name}
            >
              {mainBlog.author.name}
            </Link>
          </div>
          <p className={MainBlogPostStyle.date}>{mainBlog.date}</p>
        </div>
      </div>
    </div>
  )
}

export default MainBlogPost
